<div class="metering-point-item__overview">
  <div class="sxl-item">
      <app-disruptions-pane [currentMeteringPoint]="meteringPoint"></app-disruptions-pane>
  </div>    
   <!-- Left panel -->
  <div class="metering-point-item__overview-panel">
    <div>
      <h2 class="h3" style="margin-bottom: 0px;">{{'metering.item.overview.title'|translate}}</h2>
    </div>
    <div class="sx-contract-item">
      <div class="sx-contract-item__agreement-data-set">
        <div class="sx-contract-item__column-container">
        <div>
          <div class="sx-contract-item__agreement-data-row">
            <div class="metering-point-item__overview-label">{{'metering.item.overview.customer_name'|translate}}</div>
            <div>{{customer?.name}}</div>
            <div class="metering-point-item__overview-label">{{'metering.item.overview.meteringpoint'|translate}}</div>
            <div>{{meteringPoint.id}}</div>
            <div class="metering-point-item__overview-label">{{'metering.item.overview.address'|translate}}</div>
            <div *ngIf="meteringPoint.addresses && meteringPoint.addresses.length > 0">{{meteringPoint.addresses[0]!.street| titlecase}} {{meteringPoint.addresses[0]!.streetNo}}
              <br />{{meteringPoint.addresses[0]!.zip}} {{meteringPoint.addresses[0]!.city | titlecase}}
            </div>
             <div *ngIf="!meteringPoint.addresses || meteringPoint.addresses.length === 0">
              {{'meteringpoints.table.no_address'|translate}}
            </div>
          </div>
        
        </div>
        <div>
          <div class="sx-contract-item__agreement-data-row">
            <div class="metering-point-item__overview-label">{{'metering.item.overview.category'|translate}}</div>
            <div>{{meteringPoint.category}}</div>
            <div class="metering-point-item__overview-label">{{'metering.item.overview.area'|translate}}</div>
            <div class="metering-point-item__link"><span class="">{{meteringPoint.area}} m² </span>
              <a href="mailto:{{customerServiceEmailAddress}}?subject={{('metering.item.overview.change_area_subject' | translate:{value: meteringPointName})}}&body={{('metering.item.overview.change_area_body' | translate:{value1: meteringPointName, value2: meteringPoint.id})}}" id="mp_area_btn" class="metering-point-item__link">
                <span>{{'metering.item.overview.change_area'|translate}}</span>
              </a>
            </div>
            <div class="metering-point-item__overview-label">
              {{ (meteringPoint.meteringType===MeteringTypeEnum.Hot? 'metering.item.overview.age_hot' : 'metering.item.overview.age_cold') |translate}}
            </div>
            <div>{{ageOfCentralInYears}}&nbsp;{{'metering.item.overview.years'|translate}}</div>
          </div>
         
        </div>
      
        </div>
      </div>
      <hr class="metering-point-item__divider-gray" *ngIf="hasClimateNeutralAddition && !isWhiteLabel">

      <div class="sx-contract-item__agreement-data-set" *ngIf="hasClimateNeutralAddition && !isWhiteLabel">
        <div class="sx-contract-item__column-container">
          <div class="metering-point-item__extended-row">
            <div class="sx-contract-item__bold">{{'metering.item.overview.environment'|translate}}</div>
            <app-spinner *ngIf="isProcessing" class="sx-contract-item__budget-spinner" [showSmall]="'true'"></app-spinner>
            <div *ngIf="co2CompensationCalculated && !isProcessing">
              {{('metering.item.overview.co2_climate_compensation' | translate:{value1: co2CompensationCertificateYear, value2: co2CompensationInTons | toLocal})}}
            </div>
            <div *ngIf="co2CompensationCalculated && !isProcessing">
              <app-certificates 
                [customerName]="customer?.name" 
                [meteringPointName]="meteringPoint?.name" 
                [keyValueCO2]="co2CompensationInTons" 
                [yearOfCertificate]="co2CompensationCertificateYear">
              </app-certificates>
            </div>
          </div>
        </div>
      </div>

      <hr class="metering-point-item__divider-gray" *ngIf="meteringPoint.parentGroups && meteringPoint.parentGroups.length > 0 && this.meteringPointsCount > 1"/>

      <div class="sx-contract-item__agreement-data-set ">
        <div class="sx-contract-item__column-container">
          <div class="metering-point-item__extended-row">
            <div *ngIf="meteringPoint.parentGroups && meteringPoint.parentGroups.length > 0 && this.meteringPointsCount > 1"
              class="sx-contract-item__bold">{{'metering.item.overview.groups'|translate}}
            </div>
            <div class="sx-metering-point__chip-wrapper sxh-horizontal-stack-tiny"
              *ngIf="meteringPoint.parentGroups && meteringPoint.parentGroups.length > 0 && this.meteringPointsCount > 1"
              id="mp_groups">
              <div class="sx-chip" *ngFor="let parentGroup of meteringPoint.parentGroups">
                {{parentGroup.name}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Right panel -->
  <div class="metering-point-item__overview-panel metering-point-item__overview-panel-plate">
    <div *ngIf="!isWhiteLabel">
      <div>
        <h2 class="h3">{{'metering.item.overview.link_title'|translate}}</h2>
      </div>
      <div><a href="javascript:void(0)" appTrackClick sxaction="Link meteringpoint to contract" id="mp_contract_btn" class="metering-point-item__link"
        (click)="goToAgreement()"><span><svg class="metering-point-item__icon">
            <use xlink:href="#sx-avtal" href="#sx-avtal" />
          </svg></span><span>{{'metering.item.overview.link_aggrement'|translate}}</span></a>
      </div>
      <div [hidden]="!serviceAgreementsEnabled"><a href="javascript:void(0)" appTrackClick sxaction="Link meteringpoint to service agreements" id="mp_service_agreements_btn" class="metering-point-item__link"
        (click)="goToServiceAgreements()"><span><svg class="metering-point-item__icon">
            <use xlink:href="#sx-avtal" href="#sx-avtal" />
          </svg></span><span>{{'metering.item.overview.link_service_agreements'|translate}}</span></a>
      </div>
      <div><a href="javascript:void(0)" appTrackClick sxaction="Link meteringpoint to invoice" id="mp_invoices_btn" class="metering-point-item__link"
          (click)="goToInvoices()"><span><svg class="metering-point-item__icon">
              <use xlink:href="#sx-faktura" href="#sx-faktura" />
            </svg></span><span>{{'metering.item.overview.link_invoice'|translate}}</span></a></div>
      <div><a href="javascript:void(0)" appTrackClick sxaction="Link meteringpoint to analysis" id="mp_analyze_btn" class="metering-point-item__link"
          (click)="goToAnalyze()"><span><svg class="metering-point-item__icon">
              <use xlink:href="#sx-karriarsutveckling" href="#sx-karriarsutveckling" />
            </svg></span><span>{{'metering.item.overview.link_analyze'|translate}}</span></a></div>
      <div [hidden]="!hasManageAlarmsPermission">
        <a href="javascript:void(0)" appTrackClick sxaction="Link meteringpoint to alarm" id="mp_alarm_btn" class="metering-point-item__link"
          (click)="goToAlarm()"><span><svg class="metering-point-item__icon">
              <use xlink:href="#sx-larm" href="#sx-larm" />
            </svg></span><span>{{'metering.item.overview.link_alarm'|translate}}</span></a></div>
      <div [hidden]="this.meteringPointsCount === 1 || !hasManageGroupPermission">
        <a href="javascript:void(0)" appTrackClick sxaction="Link meteringpoint add to group" id="mp_addgroup_btn" class="metering-point-item__link"
          (click)="addToGroup()"><span><svg class="metering-point-item__icon-small">
              <use xlink:href="#baseline-add-24px" href="#baseline-add-24px" />
            </svg></span><span>{{'metering.item.overview.link_add-to-group'|translate}}</span></a></div>
      <div [hidden]="isPrivate" ><a href="javascript:void(0)" appTrackClick sxaction="Meteringpoint Report download" id="mp_report_btn" class="metering-point-item__link"
          (click)="getReport(meteringPoint.id)"><span><svg class="metering-point-item__icon">
              <use xlink:href="#sx-pdf" href="#sx-pdf" />
            </svg></span><span>{{ (meteringPoint.meteringType===MeteringTypeEnum.Hot? 'metering.item.overview.link_report_hot' : 'metering.item.overview.link_report_cold') |translate}}</span></a>
      </div>
      <!-- Industriskatt -->
      <div *ngIf="taxReturingMeteringPoint && taxReturingMeteringPointEnabled" class="metering-point-item__spinner-container" style="max-width: 150px;">
        <span matTooltip="{{ insufficentPermissions ? ('contracts.prognosis.insufficent_permissions_short'| translate) : null }}">
        <app-spinner [showSmall]="'true'" [hidden]="!exportRequested"></app-spinner>
          <a [class.disabled]="exportRequested || insufficentPermissions" (click)="displayAgreementSignPage()" class="metering-point-item__link metering-point-item__reportlink"
            >
            <span>
              <svg class="metering-point-item__icon">
                <use xlink:href="#sx-pdf" href="#sx-pdf" />
              </svg>
            </span>
            <span>{{'metering.item.overview.industrial_tax'|translate}}</span>
          </a>
        </span>
      </div>

      <!-- Intelligy -->
      <div [hidden]="!hasIntelligy || appConfig?.meteringpoint_show_intelligylinks === false || !clientIsIntelligyCompatible" class="metering-point-item__app-link-banner">
        <app-link-banner 
          id="mp_gotointelligyapp_link" 
          [disabled]="!!userInfo.impersonatedAsName" 
          (onNavigate)="goToIntelligyApplication()" 
          [matTooltipText]="matTooltipText"
          [labelIcon]="intelligyIcon">
          <span>{{'metering.item.overview.intelligy'|translate}}</span>
        </app-link-banner>
      </div>

       <!-- Dont show this link if user is Manager -->
      <div [hidden]="hasIntelligy || appConfig?.meteringpoint_show_intelligylinks === false  || !clientIsIntelligyCompatible || isManager">
        <a href="javascript:void(0)" (click)="goToIntelligyPage()" appTrackClick sxaction="Link meteringpoint about intelligy" id="mp_gotointelligypage_link" class="metering-point-item__link">
          <span><svg class="metering-point-item__icon">
            <use xlink:href="#sx-intelligy" href="#sx-intelligy" />
          </svg></span><span>{{'metering.item.overview.intelligy_more'|translate}}</span>
        </a>
      </div>
    </div>   
  </div>
  <div class="metering-point-item__information" *ngIf="meteringpointInformationGroup.informations.length !== 0 && !isWhiteLabel">
    <app-information-display 
      [showCard]="true" 
      [showHeader]="false" 
      [showIsRead]="false" 
      [iconText]="'information.group.title_icon_alterative'" 
      [informationGroup]="meteringpointInformationGroup"
      [businessArea]="businessArea">
  </app-information-display>
 </div>
 
